import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f010302e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "privacyContainer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "privacyText" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Impressum / Imprint"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" creatale GmbH"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Heilbronner Str. 42"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 71634 Ludwigsburg"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Fax: +49 7141 3099256-9"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" E-Mail: weihnachten@creatale.de"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Webseite: http://www.creatale.de"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" USt-IDNr.: DE285112068"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Geschäftsführer: Christian Dittrich"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Unternehmenssitz: Ludwigsburg"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Handelsregister Stuttgart: HRB 742907 ")
  ]),
  /*#__PURE__*/_createElementVNode("h1", null, "Datenschutzerklärung zu Christmas Dots"),
  /*#__PURE__*/_createElementVNode("h2", null, "Kontakt gemäß Art. 13 Abs. 1 Bst. a DSGVO"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Christian Dittrich"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" creatale GmbH"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Heibronner Str. 42"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 71634 Ludwigsburg")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "E-Mail-Adresse: datenschutz@creatale.de"),
  /*#__PURE__*/_createElementVNode("h2", null, "Verarbeitung personenbezogener Daten"),
  /*#__PURE__*/_createElementVNode("h3", null, "Verarbeitete Daten, Art und Zweck der Verarbeitung"),
  /*#__PURE__*/_createElementVNode("p", null, "Während der Nutzung dieser Webseite werden von Ihnen die IP-Adresse, der von Ihrem Browser verwendete User-Agent, die aufgerufene Webseite und der Zeitpunkt des Zugriffs erhoben, übermittelt, verwendet und gespeichert."),
  /*#__PURE__*/_createElementVNode("p", null, "Der von Ihrem Browser übermittelte User-Agent enthält üblicherweise Daten zum Browsertyp, dessen Version und zum Betriebssystem."),
  /*#__PURE__*/_createElementVNode("p", null, "Ihre IP-Adresse, Ihr User-Agent und die aufgerufene Webseite werden im Rahmen Ihrer Anfrage an unseren Webserver zum Zweck der Auslieferung unserer Webseite an Sie und eine eventuelle Zugriffsbeschränkung auf diese erhoben, übermittelt und verwendet. Die Rechtmäßigkeit hierfür begründet sich durch Art.6 Abs. 1 Bst. b DSGVO."),
  /*#__PURE__*/_createElementVNode("p", null, "Ihre IP-Adresse, Ihr User-Agent, die aufgerufene Webseite und der Zeitpunkt des Zugriffs werden im Rahmen Ihrer Anfrage an unseren Webserver in einem Zugriffsprotokoll zum Zweck der Sicherung unserer IT-Systeme gespeichert. Die Rechtmäßigkeit ergibt sich aus § 100 Abs. 1 TKG. Die Speicherdauer beträgt gemäß BGH Urteil vom 3.Juli 2014 Az. III ZR 391/13 7 Tage."),
  /*#__PURE__*/_createElementVNode("p", null, "Die Bereitstellung der Webserver wird in unserem Auftrag durch die Hetzner Online GmbH (Industriestr. 25, 91710 Gunzenhausen) durchgeführt. Im Rahmen dieses Vertragsverhältnis wird Ihre IP-Adresse zu Bearbeitung Ihrer Anfragen an unseren Webserver und zur Sicherung der IT-Systeme gemäß Auftragsverarbeitungsvertrag vom 25.05.2018 verarbeitet."),
  /*#__PURE__*/_createElementVNode("h3", null, "Empfänger"),
  /*#__PURE__*/_createElementVNode("p", null, "Ihre IP-Adresse, Ihr User-Agent, die aufgerufene Webseite und der Zeitpunkt des Zugriffs werden durch unseren Webserver verarbeitet und können während der Verarbeitung im Webserver von niemandem eingesehen werden. Wir nutzen zur Übertragung SSL-Verschlüsselung (HTTPS), damit Ihre personenbezogenen Daten auch während der Übertragung von niemandem eingesehen werden können."),
  /*#__PURE__*/_createElementVNode("p", null, "Auf die in Zugriffsprotokollen gespeicherten IP-Adressen, User-Agents, aufgerufenen Webseiten und Zugriffszeitpunkte haben ausschließlich unsere Administratoren Zugriff. Dies wird durch personengebundene SSH-Schlüssel und entsprechende Dateiberechtigungen sichergestellt. Der Zugriff auf die Daten erfolgt ausschließlich über verschlüsselte Transportwege (SSH)."),
  /*#__PURE__*/_createElementVNode("h3", null, "Einwilligung"),
  /*#__PURE__*/_createElementVNode("p", null, "Wir speichern den Status Ihrer Einwilligung zusammen mit einer pseudonymisierten Nutzer-ID sowohl lokal in Ihrem Browser, als auch auf einem bei Hetzner angemieteten Server. Zu Ihrer Einwilligung und eventuellen Widerrufen speichern wir den Zeitpunkt. Die Speicherung erfolgt unbegrenzt. Rechtsgrundlage hierfür ist Art. 7 Abs. 1 DSGVO."),
  /*#__PURE__*/_createElementVNode("h3", null, "Dauerhafter Spielfortschritt"),
  /*#__PURE__*/_createElementVNode("p", null, "Der von Ihnen erreichte Spielfortschritt wird lokal auf Ihrem Gerät gespeichert. Wir benutzen dafür den sogenannten Local Storage, eine in jedem Browser verfügbare Datenbank."),
  /*#__PURE__*/_createElementVNode("p", null, "Für den Spielfortschritt werden folgende Daten dauerhaft gespeichert:"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Gelöste Rätsel"),
    /*#__PURE__*/_createElementVNode("li", null, "Fortschritt eines noch nicht vollständig gelösten Rätsels")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "Diese Daten werden nicht an uns oder Dritte übertragen."),
  /*#__PURE__*/_createElementVNode("h3", null, "Erfassung Nutzerverhalten"),
  /*#__PURE__*/_createElementVNode("p", null, "Wir erfassen Daten zum Nutzerverhalten gemäß Art. 6 Abs. 1 Bst. a DSGVO ausschließlich basierend auf Ihrer Einwilligung online."),
  /*#__PURE__*/_createElementVNode("p", null, "Wir erfassen folgende Verhaltensarten von Ihnen:"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Navigation"),
    /*#__PURE__*/_createElementVNode("li", null, "Spielfortschritt (Level gestartet, Level gewonnen, Level zurückgesetzt, Tutorialschritt beendet)"),
    /*#__PURE__*/_createElementVNode("li", null, "Spielaktionen (Felder ausgefüllt)"),
    /*#__PURE__*/_createElementVNode("li", null, "Spieldauer und -frequenz")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "Die Verhaltensdaten werden Ihnen anhand einer pseudonymen Nutzer-ID zugeordnet."),
  /*#__PURE__*/_createElementVNode("p", null, "Darüber hinaus erfassen wir den Benutzen Browser, das benutzte Geräte, das benutzte Betriebssystem und die benutzte Plattform, sofern diese aus dem User-Agent hervorgehen."),
  /*#__PURE__*/_createElementVNode("p", null, "Wir erfassen die Daten zum Zwecke der statistischen Auswertung, um den reibungslosen Spielbetrieb sicherzustellen und das Spielerlebnis zu optimieren. Wir behalten uns vor, die Daten in anonymisierter und aggregierter Form zu veröffentlichen."),
  /*#__PURE__*/_createElementVNode("p", null, "Die Daten zu ihrem Nutzerverhalten werden auf unseren Servern (siehe oben) gespeichert."),
  /*#__PURE__*/_createElementVNode("h2", null, "Betroffenenrechte"),
  /*#__PURE__*/_createElementVNode("p", null, "Sie haben jederzeit das Recht"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "auf Auskunft zu den von Ihnen gespeicherten Daten gemäß Art. 15 DSGVO"),
    /*#__PURE__*/_createElementVNode("li", null, "auf Berichtigung der von Ihnen gespeicherten Daten bei Falschheit gemäß Art. 16 DSGVO"),
    /*#__PURE__*/_createElementVNode("li", null, "auf Löschung der von Ihnen gespeicherten Daten gemäß Art. 17 DSGVO"),
    /*#__PURE__*/_createElementVNode("li", null, "auf Einschränkung der Verarbeitung der von Ihnen gespeicherten Daten, sofern die die Richtigkeit der erfassten Daten bezweifeln, die Verarbeitung unrechtmäßig ist, die Daten für die Zwecke der Verarbeitung nicht mehr benötigt werden, oder Sie gemäß Art. 21 Abs. 1 DSGVO gegen die Verarbeitung Widerspruch eingelegt haben gemäß Art. 18 DSGVO"),
    /*#__PURE__*/_createElementVNode("li", null, "und auf die Übertragung der von Ihnen gespeicherten Daten an Sie oder Dritte durch Ihre Weisung gemäß Art. 20 DSGVO.")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "Anfragen hierzu richten Sie bitte an den oben angegeben Kontakt."),
  /*#__PURE__*/_createElementVNode("p", null, "Die Verarbeitung und Speicherung Ihrer IP-Adresse, Ihres User-Agents, der aufgerufenen Webseite und des Zeitpunkts des Zugriffs ist für die Bereitstellung unserer Webseite zwingend notwendig. Es besteht folglich hierzu von Ihrer Seite keine Widerspruchsmöglichkeit. "),
  /*#__PURE__*/_createElementVNode("p", null, "Sie haben das Recht bei einer Aufsichtsbehörde Beschwerde einzulegen, wenn unsere Verarbeitung Ihrer Ansicht nach gegen die DSGVO verstößt.")
], -1))
const _hoisted_3 = { class: "privacyNavigation" }
const _hoisted_4 = { class: "privacy" }
const _hoisted_5 = { class: "privacyForm" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Bevor Sie fortfahren können, lesen und akzeptieren Sie bitte die Datenschutzbestimmungen.", -1))
const _hoisted_7 = { class: "input" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "privacy1" }, " Ich akzeptiere die Datenschutzbestimmungen.", -1))
const _hoisted_9 = { class: "input" }
const _hoisted_10 = { for: "privacy2" }
const _hoisted_11 = { class: "input" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "privacy3" }, " Ich bestätige, dass ich mindestens 18 Jahre alt bin und im Land meines Wohnsitzes die Volljährigkeit erreicht habe.", -1))
const _hoisted_13 = { class: "privacyButton" }
const _hoisted_14 = { class: "navigation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_navigation_button = _resolveComponent("navigation-button")!
  const _component_modal = _resolveComponent("modal")!
  const _component_Headline = _resolveComponent("Headline")!
  const _component_BreakLine = _resolveComponent("BreakLine")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_modal, {
      "is-visible": _ctx.showText,
      noTransition: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_navigation_button, {
              title: "Zurück",
              "text-size": "20px",
              "text-line-height": "30px",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showText = false))
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["is-visible"]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Headline, {
        title: "Datenschutz",
        class: "pt-32"
      }),
      _createElementVNode("form", _hoisted_5, [
        _createVNode(_component_BreakLine),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: "privacy1",
            name: "privacy1",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.privacyStatementChecked) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.privacyStatementChecked]
          ]),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: "privacy2",
            name: "privacy2",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.gameAnalyticsChecked) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.gameAnalyticsChecked]
          ]),
          _createElementVNode("label", _hoisted_10, " Ich stimme zu, dass Daten über mein Verhalten im Spiel gesammelt und an " + _toDisplayString(_ctx.trackerTarget) + " gesendet werden.", 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: "privacy3",
            name: "privacy3",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.fullAgeChecked) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.fullAgeChecked]
          ]),
          _hoisted_12
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_navigation_button, {
            title: "Datenschutzbestimmungen lesen",
            "text-size": "14px",
            icon: "chevron-right",
            "icon-size": "1x",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showText = true))
          })
        ]),
        _createVNode(_component_BreakLine),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_navigation_button, {
            title: "Einwilligung abgeben und Fortfahren",
            "text-size": "20px",
            "text-line-height": "30px",
            onClick: _ctx.handleGdpr,
            disabled: _ctx.disableContinue
          }, null, 8, ["onClick", "disabled"])
        ])
      ])
    ])
  ], 64))
}